import {
    CLEAR_ALL_STATES,
    CLEAR_TWO_FACTOR_CHALLENGE,
    RESET_TWO_FACTOR_SETTINGS,
    SET_TWO_FACTOR_CHALLENGE,
    SET_TWO_FACTOR_SETTINGS
} from "../types/types";
import {TwoFactorSetup} from "../../utils/twoFactorAuth";

export type TwoFactorState = {
    challengeToken: string | null;
    challengeUserName: string | null;
    error: string | null;
    loading: boolean;
    enabled: boolean | null;
    setup: TwoFactorSetup | null;
    backupCodes: string[] | null;
    settingsError: string | null;
    settingsLoading: boolean;
    enrollmentQr: string | null;
    awaitingAuthCode: boolean;
    authNotice: string | null;
    loginSuccessNotice: string | null;
};

const initialState: TwoFactorState = {
    challengeToken: null,
    challengeUserName: null,
    error: null,
    loading: false,
    enabled: null,
    setup: null,
    backupCodes: null,
    settingsError: null,
    settingsLoading: false,
    enrollmentQr: null,
    awaitingAuthCode: false,
    authNotice: null,
    loginSuccessNotice: null
};

export const TwoFactorReducer = (state = initialState, action: any): TwoFactorState => {
    switch (action.type) {
        case SET_TWO_FACTOR_CHALLENGE:
            return {
                ...state,
                challengeToken: action.payload?.challengeToken || null,
                challengeUserName: action.payload?.userName || null,
                error: null,
                loading: false
            };
        case CLEAR_TWO_FACTOR_CHALLENGE:
            return {
                ...state,
                challengeToken: null,
                challengeUserName: null,
                error: null,
                loading: false,
                enrollmentQr: null,
                awaitingAuthCode: false,
                authNotice: null
            };
        case SET_TWO_FACTOR_SETTINGS:
            return {...state, ...action.payload};
        case RESET_TWO_FACTOR_SETTINGS:
            return {
                ...state,
                enabled: null,
                setup: null,
                backupCodes: null,
                settingsError: null,
                settingsLoading: false,
                enrollmentQr: null,
                awaitingAuthCode: false,
                authNotice: null
            };
        case CLEAR_ALL_STATES:
            return initialState;
        default:
            return state;
    }
};
